import type { StripeProduct } from "@/API";
import { create } from "zustand";

type UserPlanState = {
  plan?: StripeProduct;
};

export const userPlanState = create<UserPlanState>(() => ({
  plan: undefined,
}));

export const setPlan = (plan: StripeProduct) =>
  userPlanState.setState(() => ({ plan: plan }));
